import React, { forwardRef } from 'react'
import Icon from 'common/Icon'
import { MADISON_BLUE } from 'constants/colors'
import classNames from 'classnames'
import styles from './index.module.scss'

const CustomToggle = forwardRef<HTMLDivElement, CustomToggleProps>(
  (
    {
      isToggleOpen,
      onClick,
      setToggleState,
      containerClassName,
      anchorClassName,
      icon,
      iconClassName = '',
      children,
    },
    ref
  ) => (
    <div
      className={classNames(containerClassName, styles.toggle_container)}
      ref={ref}
      onClick={(e) => {
        setToggleState(!isToggleOpen)
        e.preventDefault()
        onClick?.(e)
      }}
    >
      {children}
      {icon && (
        <button
          className={`${anchorClassName} button_default`}
          aria-label="Toggle dropdown"
        >
          <Icon icon={icon} className={iconClassName} fill={MADISON_BLUE} />
        </button>
      )}
    </div>
  )
)

export default CustomToggle
